import { defineMessages } from 'react-intl';

export default defineMessages({
  unit: {
    id: 'unit',
    description: 'unit',
    defaultMessage: 'unit',
  },
  units: {
    id: 'units',
    description: 'units',
    defaultMessage: 'units',
  },
  submittedNotifcationStart: {
    id: 'submittedNotifcationStart',
    description: 'you have already submitted',
    defaultMessage: 'You have already submitted',
  },
  submittedNotifcationEnd: {
    id: 'submittedNotifcationEnd',
    description: 'for this configuration',
    defaultMessage: 'for this configuration',
  },
});
